<script lang="ts">
	import '../app.css';
	import '../../node_modules/prism-themes/themes/prism-vsc-dark-plus.css';

	import Header from '$lib/components/header.svelte';
	import Main from '$lib/components/main.svelte';
	import Footer from '$lib/components/footer.svelte';
	import {
		appName,
		appKeywords,
		appDescription,
		appAuthor,
		siteBaseUrl,
		blogBaseUrl
	} from '$lib/meta';
	import image from '$lib/assets/android-chrome-512x512.png';
	import { onMount } from 'svelte';
	import { onNavigate } from '$app/navigation';

	onNavigate((navigation) => {
		if (!document.startViewTransition) return;

		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
			});
		});
	});

	onMount(() => {
		(window.adsbygoogle = window.adsbygoogle || []).push({});
	});
</script>

<svelte:head>
	<title>{appName}</title>

	<meta name="description" content={appDescription} />
	<meta name="keywords" content={appKeywords.join(', ')} />

	<meta name="author" content={appAuthor} />

	<meta property="og:site_name" content={appName} />
	<meta property="og:title" content={appName} />
	<meta property="og:description" content={appDescription} />
	<meta property="og:url" content={blogBaseUrl} />
	<meta property="og:type" content="website" />
	<meta property="og:locale" content="en-GB" />
	<meta property="og:image" content={image} />
	<meta
		property="og:image:secure_url"
		content="https://siposdani87.com/assets/images/favicons/android-chrome-512x512.png"
	/>
	<meta property="og:image:type" content="image/png" />
	<meta property="og:image:width" content="512" />
	<meta property="og:image:height" content="512" />
	<meta property="og:image:alt" content="siposdani87 logo" />

	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:site" content="@siposdani87" />

	<link
		rel="alternate"
		type="application/rss+xml"
		title="RSS Feed for BLOG.siposdani87"
		href="/rss.xml"
	/>

	<link rel="alternate" hreflang="en" href={blogBaseUrl} />
	<link rel="author" href={siteBaseUrl} />

	<meta name="llms" content="/llms.txt" />

	{@html `<script type="application/ld+json">${JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'WebSite',
		name: appName,
		url: blogBaseUrl,
		description: appDescription,
		inLanguage: 'en',
		author: {
			'@type': 'Person',
			name: appAuthor,
			url: siteBaseUrl,
			sameAs: ['https://github.com/siposdani87', 'https://twitter.com/siposdani87']
		}
	})}</script>`}
</svelte:head>

<a
	href="#main-content"
	class="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:p-2 focus:bg-white focus:text-black"
	>Skip to main content</a
>
<Header />
<Main>
	<slot />
	<!-- blog.siposdani87 -->
	<ins
		class="adsbygoogle"
		style="display:block"
		data-ad-client="ca-pub-9025727238520621"
		data-ad-slot="6677427074"
		data-ad-format="auto"
		data-full-width-responsive="true"
	></ins>
</Main>
<Footer />
